import { Link } from 'react-router-dom'

const TailwindSamplePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center space-x-4">
              <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors">
                ← Back to Home
              </Link>
              <h1 className="text-3xl font-bold text-gray-900">Tailwind CSS Demo</h1>
            </div>
            <div className="flex items-center space-x-2">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                Tailwind v4
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
            <span className="block">Welcome to</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              Tailwind CSS
            </span>
          </h2>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            A utility-first CSS framework for rapidly building custom user interfaces.
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {/* Card 1 - Colors & Typography */}
          <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold">A</span>
                </div>
                <h3 className="ml-3 text-lg font-semibold text-gray-900">Colors & Typography</h3>
              </div>
              <p className="text-gray-600 mb-4">
                Explore Tailwind's color palette and typography utilities.
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-red-500 rounded"></div>
                  <span className="text-sm text-gray-700">Red 500</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-green-500 rounded"></div>
                  <span className="text-sm text-gray-700">Green 500</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-blue-500 rounded"></div>
                  <span className="text-sm text-gray-700">Blue 500</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 - Spacing & Layout */}
          <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold">B</span>
                </div>
                <h3 className="ml-3 text-lg font-semibold text-gray-900">Spacing & Layout</h3>
              </div>
              <p className="text-gray-600 mb-4">
                Master spacing, flexbox, and grid layout utilities.
              </p>
              <div className="space-y-2">
                <div className="flex space-x-2">
                  <div className="w-8 h-8 bg-gray-200 rounded flex items-center justify-center text-xs">1</div>
                  <div className="w-8 h-8 bg-gray-300 rounded flex items-center justify-center text-xs">2</div>
                  <div className="w-8 h-8 bg-gray-400 rounded flex items-center justify-center text-xs">3</div>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  <div className="h-6 bg-blue-200 rounded"></div>
                  <div className="h-6 bg-blue-300 rounded"></div>
                  <div className="h-6 bg-blue-400 rounded"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 - Interactive Elements */}
          <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-purple-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold">C</span>
                </div>
                <h3 className="ml-3 text-lg font-semibold text-gray-900">Interactive Elements</h3>
              </div>
              <p className="text-gray-600 mb-4">
                Buttons, hover states, and interactive components.
              </p>
              <div className="space-y-3">
                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200">
                  Primary Button
                </button>
                <button className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors duration-200">
                  Secondary Button
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Responsive Design Demo */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Responsive Design</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-blue-100 p-4 rounded-lg text-center">
              <div className="text-2xl font-bold text-blue-600">Mobile</div>
              <div className="text-sm text-blue-500">1 column</div>
            </div>
            <div className="bg-green-100 p-4 rounded-lg text-center">
              <div className="text-2xl font-bold text-green-600">Tablet</div>
              <div className="text-sm text-green-500">2 columns</div>
            </div>
            <div className="bg-purple-100 p-4 rounded-lg text-center">
              <div className="text-2xl font-bold text-purple-600">Desktop</div>
              <div className="text-sm text-purple-500">4 columns</div>
            </div>
            <div className="bg-orange-100 p-4 rounded-lg text-center">
              <div className="text-2xl font-bold text-orange-600">Large</div>
              <div className="text-sm text-orange-500">4 columns</div>
            </div>
          </div>
        </div>

        {/* Animation Demo */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Animations & Transitions</h3>
          <div className="flex flex-wrap gap-4">
            <div className="animate-bounce bg-blue-500 text-white p-4 rounded-lg">
              Bounce
            </div>
            <div className="animate-pulse bg-green-500 text-white p-4 rounded-lg">
              Pulse
            </div>
            <div className="animate-spin bg-purple-500 text-white p-4 rounded-lg">
              Spin
            </div>
            <div className="transform hover:scale-110 transition-transform duration-200 bg-orange-500 text-white p-4 rounded-lg cursor-pointer">
              Hover Scale
            </div>
          </div>
        </div>

        {/* Form Demo */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Form Elements</h3>
          <form className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your email"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                Message
              </label>
              <textarea
                id="message"
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200"
            >
              Send Message
            </button>
          </form>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gray-300">
              Built with Tailwind CSS v4 • 
              <a href="https://tailwindcss.com" className="text-blue-400 hover:text-blue-300 ml-1">
                Learn More
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default TailwindSamplePage
